(function(){
  function initProduct(root){
    if(root.dataset.lvInit)return; root.dataset.lvInit='1';
    var main=root.querySelector('[data-lv-main-img]');
    root.querySelectorAll('[data-lv-thumb]').forEach(function(t){
      t.addEventListener('click',function(){
        var full=t.getAttribute('data-full');
        if(main&&full){main.src=full;main.removeAttribute('srcset');}
        root.querySelectorAll('[data-lv-thumb]').forEach(function(x){x.classList.remove('is-active');});
        t.classList.add('is-active');
      });
    });
    var thumbRow=root.querySelector('[data-lv-thumbs]');
    var thumbNav=root.querySelector('[data-lv-thumbnav]');
    if(thumbRow&&thumbNav){thumbNav.addEventListener('click',function(){thumbRow.scrollBy({left:170,behavior:'smooth'});});}
    var form=root.querySelector('[data-lv-form]');
    var idInput=root.querySelector('[data-lv-id]');
    var atcBtn=root.querySelector('[data-lv-atc]');
    var atcLabel=root.querySelector('[data-lv-atc-label]');
    var atcPrice=root.querySelector('[data-lv-atc-price]');
    var stickyPrice=root.querySelector('[data-lv-sticky-price]');
    var errEl=root.querySelector('[data-lv-error]');
    function select(inp){
      var price=inp.getAttribute('data-price');
      var avail=inp.getAttribute('data-available')==='true';
      if(idInput)idInput.value=inp.value;
      var bp=root.querySelector('[data-lv-bundle-input]');
      if(bp){bp.value=inp.getAttribute('data-label')||'';}
      if(atcPrice)atcPrice.textContent=price;
      if(stickyPrice)stickyPrice.textContent=price;
      root.querySelectorAll('[data-lv-bundle]').forEach(function(c){c.classList.toggle('is-selected',c.contains(inp));});
      if(atcBtn){atcBtn.disabled=!avail;}
      if(atcLabel){atcLabel.textContent=avail?(atcBtn.getAttribute('data-label')||'Add to cart'):'Sold out';}
    }
    var inputs=root.querySelectorAll('[data-lv-variant-input]');
    inputs.forEach(function(inp){inp.addEventListener('change',function(){select(inp);});});
    var checked=root.querySelector('[data-lv-variant-input]:checked');
    if(checked)select(checked); else if(inputs[0]){inputs[0].checked=true;select(inputs[0]);}
    root.querySelectorAll('[data-lv-qty-btn]').forEach(function(b){
      b.addEventListener('click',function(){var q=root.querySelector('[data-lv-qty]');if(!q)return;var v=parseInt(q.value||'1',10);v+=(b.getAttribute('data-dir')==='up'?1:-1);if(v<1)v=1;q.value=v;});
    });
    var stickyBtn=root.querySelector('[data-lv-sticky-btn]');
    if(stickyBtn&&form){stickyBtn.addEventListener('click',function(){if(typeof form.requestSubmit==='function')form.requestSubmit();else form.submit();});}
    if(form){
      form.addEventListener('submit',function(e){
        e.preventDefault();
        if(errEl){errEl.hidden=true;errEl.textContent='';}
        if(atcBtn)atcBtn.classList.add('is-loading');
        var qEl=root.querySelector('[data-lv-qty]');
        var qv=(qEl?parseInt(qEl.value,10):1)||1;
        var idv=idInput?idInput.value:null;
        var bpi=root.querySelector('[data-lv-bundle-input]');
        var props=(bpi&&bpi.value)?{Bundle:bpi.value}:null;
        var cartUrl=(window.routes&&window.routes.cart_url)||'/cart';
        function done(res){
          if(atcBtn)atcBtn.classList.remove('is-loading');
          if(res&&res.status){if(errEl){errEl.hidden=false;errEl.textContent=res.description||res.message||'Could not add to cart';}return;}
          if(atcLabel){var o=atcLabel.textContent;atcLabel.textContent='✓ Added to cart';setTimeout(function(){atcLabel.textContent=o;},1800);}
        }
        if(window.LanviaraCart&&idv){
          window.LanviaraCart.add(idv,qv,true,props).then(done).catch(function(){window.location=cartUrl;});
        }else{
          var fd=new FormData(form);
          fetch((window.routes&&window.routes.cart_add_url)||'/cart/add',{method:'POST',body:fd}).then(function(){window.location=cartUrl;}).catch(function(){window.location=cartUrl;});
        }
      });
    }
  }
  function initStrip(root){
    if(root.dataset.lvInit)return; root.dataset.lvInit='1';
    var slides=root.querySelectorAll('[data-lv-slide]');
    var dots=root.querySelectorAll('[data-lv-dot]');
    if(!slides.length)return;var i=0;
    function show(n){i=(n+slides.length)%slides.length;slides.forEach(function(s,k){s.hidden=k!==i;});dots.forEach(function(d,k){d.classList.toggle('is-active',k===i);});}
    var prev=root.querySelector('[data-lv-prev]');var next=root.querySelector('[data-lv-next]');
    if(prev)prev.addEventListener('click',function(){show(i-1);});
    if(next)next.addEventListener('click',function(){show(i+1);});
    dots.forEach(function(d,k){d.addEventListener('click',function(){show(k);});});
    show(0);
  }
  function initAcc(root){
    if(root.dataset.lvInit)return; root.dataset.lvInit='1';
    root.querySelectorAll('.lv-acc__q').forEach(function(q){
      q.addEventListener('click',function(){
        var item=q.closest('.lv-acc__item');var open=item.classList.contains('is-open');
        if(!root.hasAttribute('data-lv-multi')){root.querySelectorAll('.lv-acc__item').forEach(function(it){it.classList.remove('is-open');it.querySelector('.lv-acc__q').setAttribute('aria-expanded','false');});}
        if(open){item.classList.remove('is-open');q.setAttribute('aria-expanded','false');}else{item.classList.add('is-open');q.setAttribute('aria-expanded','true');}
      });
    });
  }
  function initAll(ctx){
    (ctx||document).querySelectorAll('[data-lv-product]').forEach(initProduct);
    (ctx||document).querySelectorAll('[data-lv-strip]').forEach(initStrip);
    (ctx||document).querySelectorAll('[data-lv-acc]').forEach(initAcc);
  }
  if(document.readyState!=='loading')initAll();else document.addEventListener('DOMContentLoaded',function(){initAll();});
  document.addEventListener('shopify:section:load',function(e){initAll(e.target);});
})();
